var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26184_7272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.66667H8.66667C8.3 8.66667 8 8.96666 8 9.33333V11.3333C8 11.7 8.3 12 8.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9.33333C11.3333 8.96666 11.0333 8.66667 10.6667 8.66667ZM10.6667 2V2.66667H5.33333V2C5.33333 1.63333 5.03333 1.33333 4.66667 1.33333C4.3 1.33333 4 1.63333 4 2V2.66667H3.33333C2.59333 2.66667 2.00667 3.26667 2.00667 4L2 13.3333C2 14.0667 2.59333 14.6667 3.33333 14.6667H12.6667C13.4 14.6667 14 14.0667 14 13.3333V4C14 3.26667 13.4 2.66667 12.6667 2.66667H12V2C12 1.63333 11.7 1.33333 11.3333 1.33333C10.9667 1.33333 10.6667 1.63333 10.6667 2ZM12 13.3333H4C3.63333 13.3333 3.33333 13.0333 3.33333 12.6667V6H12.6667V12.6667C12.6667 13.0333 12.3667 13.3333 12 13.3333Z",
    fill: "#6A6DA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26184_7272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.c3e58db4.svg";
export { ForwardRef as ReactComponent };